import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, SimpleChanges, ViewChild, ChangeDetectionStrategy } from '@angular/core';

import { Message             } from '@shared/factories';
import { NotificationService } from '@shared/services';

@Component({
  selector:      'chat-box-message',
  templateUrl: './chat-box-message.component.html',
  host: { class: 'am-flex-column gap-xxs' },
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ChatBoxMessageComponent implements OnInit {
  @Input() chatFullAccess:  boolean;
  @Input() message:         Message;
  @Input() prevMessage:     Message;
  @Input() nextMessage:     Message;
  @Input() showDate:        boolean;
  @Input() editMode:        number;
  @Input() index:           number;
  @Input() myId:            number;
  @Input() ownerId:         number;
  @Input() participantName: string;

  bubbleStyle:              string;
  tempText:                 string;

  @ViewChild('content') content!: ElementRef;
  @Output() edit   = new EventEmitter<Message>();
  @Output() delete = new EventEmitter<Message>();

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (this.editMode) {
      let clickedInside = this.content.nativeElement.contains(event.target);
      if (!clickedInside) this.resetEdit();
    }
  }

  constructor(
    private notificationService: NotificationService
  ) { }

  ngOnInit(): void {
    this.updateBubbleStyle();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes?.message?.firstChange || !changes?.nextMessage?.firstChange || !changes?.prevMessage?.firstChange) this.updateBubbleStyle();
  }

  private updateBubbleStyle(): void {
    let style = '';
    if      (this.message.bulkMessageId)      style = 'mla mra mbs';
    else if (this.isOwnMessage(this.message)) style = 'mla';
    else                                      style = 'mra';

    if      (this.message.deletedAt)          style += ' b-grey';
    else if (this.isOwnMessage(this.message)) style += ' bg-blue color-white';
    else                                      style += ' bg-white b-grey';
  
    if (!this.message.deletedAt && this.message.bulkMessageId) style += ' b-orange';

    if (!this.message.bulkMessageId && this.nextMessage?.participantId !== this.message.participantId) style += ' mb-s ' + (this.isOwnMessage(this.message) ? 'bbr-radius-xxs' : 'bbl-radius-xxs');

    this.bubbleStyle = style;
  }

  isOwnMessage(message: Message): boolean {
    return !message?.bulkMessageId && message?.participantId === this.myId;
  }

  messageIsRead(message: Message): boolean {
    return message?.viewerIds?.includes(this.ownerId);
  }

  goEditMode(e: Event): void {
    e.stopPropagation();
    this.editMode = this.message.id;
    this.tempText = this.message.text;
    setTimeout(() => {
      let input = document.getElementById('update-box');
      input.addEventListener('input', () => {
        input.style.height = 'auto';
        input.style.height = input.scrollHeight + 'px';
      });
      input.focus();
    });
  }

  private resetEdit(): void {
    this.message.text = this.tempText;
    this.editMode     = null;
    this.tempText     = null;
  }

  confirmDelete(message: Message): void {
    this.notificationService.confirm(
      'Warnung',
      'Möchten Sie diese Nachricht wirklich löschen?',
      () => this.delete.emit(message)
    );
  }

  showParticipantName(): boolean {
    if (this.isOwnMessage(this.message))                                           return false;
    if (!this.index)                                                               return true;
    if (this.prevMessage?.deletedAt)                                               return true;
    if (this.prevMessage?.bulkMessageId)                                           return true;
    if (this.message.participantId       !== this.prevMessage?.participantId)      return true;
    if (this.message.createdAt.getDate() !== this.prevMessage.createdAt.getDate()) return true;
    return false;
  }

}
